function FormatMinFilter() {
  return function (min) {
    min = min || 0;
    min = parseFloat(min);

    if (min > 50) {
      min = `  $${min}`;
    } else if (min <= 50 && min > 0) {
      min = ` ${min} Btls.`;
    } else if (min === 0) {
      min = 'No Min.';
    }

    return min;
  };
}

FormatMinFilter.$inject = [];

export default FormatMinFilter;



// WEBPACK FOOTER //
// ./src/filters/formatMinFilter.js